import { MINUTE_IN_MS } from './time';

export const USERS_PAGE_DEFAULT = Number(process.env.REACT_APP_USER_PAGE ?? 1);
export const USERS_LIMIT_DEFAULT = Number(
  process.env.REACT_APP_USER_LIMIT ?? 10,
);
export const ASSIGNEE_SEARCH_DEBOUNCE_MS = 300;
export const USER_LOOKUP_CACHE_TTL_MS = 10 * MINUTE_IN_MS;
